import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip/Tooltip';

const ImageCard = ({ image, imageAlt, icon, onClick, tooltip }) => {
  // Ensure image path starts with /storage/presentation_images/
  const imageSrc =
    image && !image.startsWith('/storage/presentation_images/')
      ? `/storage/presentation_images/${image}`
      : image;

  const cardContent = (
    <div
      onClick={onClick}
      className={`image-card-comp-container ${onClick && 'clickable'}`}
    >
      <div className="image-container">
        <img src={imageSrc} alt={imageAlt} />
      </div>
      <div className="icon-wrapper">{icon && <i className={icon} />}</div>
    </div>
  );

  return tooltip ? (
    <>
      <Tooltip tooltip={tooltip}>{cardContent}</Tooltip>
    </>
  ) : (
    <>{cardContent}</>
  );
};

ImageCard.propTypes = {
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
};

export default ImageCard;
